import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse, type ContactWebsite } from "@/lib/types";
import { omit } from "lodash";
import { baseContactRoute } from "./contact";

// #region --------------- Contact Website API requests -----------------
export function createContactWebsiteV1(
  data: Pick<ContactWebsite, "address" | "label" | "contactId"> &
    Partial<ContactWebsite>,
) {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<ContactWebsite>>(`${baseContactRoute}/websites`, data)
    .then((res) => res.data);
}

export function updateContactWebsiteV1(
  data: Pick<ContactWebsite, "contactId" | "id" | "dateModified"> &
    Partial<ContactWebsite>,
) {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<ContactWebsite>
    >(`${baseContactRoute}/websites`, omit(data, "contactId"))
    .then((res) => res.data);
}

export function deleteContactWebsiteV1({
  id,
}: {
  contactId: string;
  id: string;
}) {
  return authenticatedFastApiAxiosInstance
    .delete<APIResponse<ContactWebsite>>(`${baseContactRoute}/websites/${id}`)
    .then((res) => res.data);
}

// #endregion --------------- Contact Website API requests -----------------
